<template>
  <base-page :title="$t('l.res_manage')" icon="md-apps" class="page-res">
    <Row slot="extra" type="flex" justify="end">
      <Col>
        <Button type="primary" @click="startRedisTest">{{ $t('l.redis_test') }}</Button>
      </Col>
      <Col class="margin-left-5">
        <Button type="primary" @click="startRedisSTAT">{{ $t('l.redis_count') }}</Button>
      </Col>
      <Col class="margin-left-5">
        <Button @click="getResources">{{ $t('l.fresh') }}</Button>
      </Col>
    </Row>
    <template>
      <div class="full">
        <Collapse v-model="sysTab">
          <Panel name="sys">
            {{ $t('l.platform_res') }}
            <div slot="content" class="menu1" v-for="(layer1,index1) of sysList" v-bind:key="layer1.id">
              <div class="menu-box1">
                <!--<Tooltip :delay="500">-->
                <span class="auth-res-item" v-bind:class="{'active':layer1.id == selectedId}"
                      v-on:click="setActive(layer1)"
                      @contextmenu.prevent="onContextMenu($event, layer1, 1)">{{ layer1.res_name }}<br>{{ layer1.res_key }}<br>{{ layer1.uri }}</span>
                <div class="tool-tip-content" slot="content">
                  <p @click="copyText(layer1.res_key)">key: <span class="yellow">{{ layer1.res_key }}</span></p>
                  <p @click="copyText(layer1.uri)">uri: <span class="yellow">{{ layer1.uri }}</span></p>
                  <p>remark: <span class="yellow">{{ layer1.remark }}</span></p>
                </div>
                <!--</Tooltip>-->

              </div>
              <div class="menu1-children">
                <div class="menu2" v-for="(layer2,index2) of layer1.children" :key="layer2.id">
                  <div class="menu-box2">
                    <!--<Tooltip :delay="500">-->
                    <span class="auth-res-item" v-bind:class="{'active':layer2.id == selectedId}"
                          v-on:click="setActive(layer2)"
                          @contextmenu.prevent="onContextMenu($event, layer2, 2)">{{ layer2.res_name }}<br>{{ layer2.res_key }}<br>{{ layer2.uri }}</span>
                    <div class="tool-tip-content" slot="content">
                      <p @click="copyText(layer2.res_key)">key: <span class="yellow">{{ layer2.res_key }}</span></p>
                      <p @click="copyText(layer2.uri)">uri: <span class="yellow">{{ layer2.uri }}</span></p>
                      <p>remark: <span class="yellow">{{ layer2.remark }}</span></p>
                    </div>
                    <!--</Tooltip>-->

                  </div>
                  <div class="menu2-children">
                    <div class="menu3">
                      <div class="menu-box3">
                        <!--layer3-->
                        <span v-for="(layer3,index3) of layer2.children" :key="layer3.id">
                                                    <span class="auth-res-item"
                                                          v-bind:class="{'active':layer3.id == selectedId}"
                                                          v-on:click="setActive(layer3)"
                                                          @contextmenu.prevent="onContextMenu($event, layer3, 3)">{{ layer3.res_name }}<br>{{ layer3.res_key }}<br>{{ layer3.uri }}</span>
                                                    <div class="tool-tip-content" slot="content">
                                                        <p @click="copyText(layer3.res_key)">key: <span class="yellow">{{ layer3.res_key }}</span></p>
                                                        <p @click="copyText(layer3.uri)">uri: <span
                                                            class="yellow">{{ layer3.uri }}</span></p>
                                                        <p>remark: <span class="yellow">{{ layer3.remark }}</span></p>
                                                    </div>
                                                </span>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Panel>
          <Panel name="app">
            {{ $t('l.app_res') }}
            <div slot="content" class="menu1" v-for="(layer1,index1) of appList" v-bind:key="layer1.id">
              <div class="menu-box1">
                <!--<Tooltip :delay="500">-->
                <span class="auth-res-item" v-bind:class="{'active':layer1.id == selectedId}"
                      v-on:click="setActive(layer1)"
                      @contextmenu.prevent="onContextMenu($event, layer1, 1)">{{ layer1.res_name }}<br>{{ layer1.res_key }}<br>{{ layer1.uri }}</span>
                <div class="tool-tip-content" slot="content">
                  <p @click="copyText(layer1.res_key)">key: <span class="yellow">{{ layer1.res_key }}</span></p>
                  <p @click="copyText(layer1.uri)">uri: <span class="yellow">{{ layer1.uri }}</span></p>
                  <p>remark: <span class="yellow">{{ layer1.remark }}</span></p>
                </div>
                <!--</Tooltip>-->

              </div>
              <div class="menu1-children">
                <div class="menu2" v-for="(layer2,index2) of layer1.children" :key="layer2.id">
                  <div class="menu-box2">
                    <!--<Tooltip :delay="500">-->
                    <span class="auth-res-item" v-bind:class="{'active':layer2.id == selectedId}"
                          v-on:click="setActive(layer2)"
                          @contextmenu.prevent="onContextMenu($event, layer2, 2)">{{ layer2.res_name }}<br>{{ layer2.res_key }}<br>{{ layer2.uri }}</span>
                    <div class="tool-tip-content" slot="content">
                      <p @click="copyText(layer2.res_key)">key: <span class="yellow">{{ layer2.res_key }}</span></p>
                      <p @click="copyText(layer2.uri)">uri: <span class="yellow">{{ layer2.uri }}</span></p>
                      <p>remark: <span class="yellow">{{ layer2.remark }}</span></p>
                    </div>
                    <!--</Tooltip>-->
                  </div>
                  <div class="menu2-children">
                    <div class="menu3">
                      <div class="menu-box3">
                        <!--layer3-->
                        <span v-for="(layer3,index3) of layer2.children" :key="layer3.id">
                                                    <span class="auth-res-item"
                                                          v-bind:class="{'active':layer3.id == selectedId}"
                                                          v-on:click="setActive(layer3)"
                                                          @contextmenu.prevent="onContextMenu($event, layer3, 3)">{{ layer3.res_name }}<br>{{ layer3.res_key }}<br>{{ layer3.uri }}</span>
                                                    <div class="tool-tip-content" slot="content">
                                                        <p @click="copyText(layer3.res_key)">key: <span class="yellow">{{ layer3.res_key }}</span></p>
                                                        <p @click="copyText(layer3.uri)">uri: <span
                                                            class="yellow">{{ layer3.uri }}</span></p>
                                                        <p>remark: <span class="yellow">{{ layer3.remark }}</span></p>
                                                    </div>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </Panel>

          <!--                  2024年12月6日  王欢  新增电梯专家资源-->
          <Panel name="dtzj">
            {{ $t('l.dtzj_res') }}
            <div slot="content" class="menu1" v-for="(layer1,index1) of dtzjList" v-bind:key="layer1.id">
              <div class="menu-box1">
                <!--<Tooltip :delay="500">-->
                <span class="auth-res-item" v-bind:class="{'active':layer1.id == selectedId}"
                      v-on:click="setActive(layer1)"
                      @contextmenu.prevent="onContextMenu($event, layer1, 1)">{{ layer1.res_name }}<br>{{ layer1.res_key }}<br>{{ layer1.uri }}</span>
                <div class="tool-tip-content" slot="content">
                  <p @click="copyText(layer1.res_key)">key: <span class="yellow">{{ layer1.res_key }}</span></p>
                  <p @click="copyText(layer1.uri)">uri: <span class="yellow">{{ layer1.uri }}</span></p>
                  <p>remark: <span class="yellow">{{ layer1.remark }}</span></p>
                </div>

              </div>
              <div class="menu1-children">
                <div class="menu2" v-for="(layer2,index2) of layer1.children" :key="layer2.id">
                  <div class="menu-box2">
                    <!--<Tooltip :delay="500">-->
                    <span class="auth-res-item" v-bind:class="{'active':layer2.id == selectedId}"
                          v-on:click="setActive(layer2)"
                          @contextmenu.prevent="onContextMenu($event, layer2, 2)">{{ layer2.res_name }}<br>{{ layer2.res_key }}<br>{{ layer2.uri }}</span>
                    <div class="tool-tip-content" slot="content">
                      <p @click="copyText(layer2.res_key)">key: <span class="yellow">{{ layer2.res_key }}</span></p>
                      <p @click="copyText(layer2.uri)">uri: <span class="yellow">{{ layer2.uri }}</span></p>
                      <p>remark: <span class="yellow">{{ layer2.remark }}</span></p>
                    </div>
                    <!--</Tooltip>-->
                  </div>
                  <div class="menu2-children">
                    <div class="menu3">
                      <div class="menu-box3">
                        <!--layer3-->
                        <span v-for="(layer3,index3) of layer2.children" :key="layer3.id">
                                                    <span class="auth-res-item"
                                                          v-bind:class="{'active':layer3.id == selectedId}"
                                                          v-on:click="setActive(layer3)"
                                                          @contextmenu.prevent="onContextMenu($event, layer3, 3)">{{ layer3.res_name }}<br>{{ layer3.res_key }}<br>{{ layer3.uri }}</span>
                                                    <div class="tool-tip-content" slot="content">
                                                        <p @click="copyText(layer3.res_key)">key: <span class="yellow">{{ layer3.res_key }}</span></p>
                                                        <p @click="copyText(layer3.uri)">uri: <span
                                                            class="yellow">{{ layer3.uri }}</span></p>
                                                        <p>remark: <span class="yellow">{{ layer3.remark }}</span></p>
                                                    </div>
                                                </span>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </Panel>


        </Collapse>
      </div>
      <lg-modal :show="showModal"
                @on-visible-change="(e)=>{modal.showModal = e}"
                title="资源"
                @on-cancel="showModal = false"
                :loading="loading"
                @on-submit="save">
        <Form :model="currentRes" :label-width="80">
          <FormItem label="资源名">
            <Input v-model="currentRes.res_name" placeholder="资源名"></Input>
          </FormItem>
          <FormItem label="资源名(英文)">
            <Input v-model="currentRes.res_name_en_us" placeholder="资源名(英文)"></Input>
          </FormItem>
          <FormItem label="资源标识">
            <Input v-model="currentRes.res_key" placeholder="资源唯一标识"></Input>
          </FormItem>
          <FormItem label="url">
            <Input v-model="currentRes.uri" placeholder="url/route"></Input>
          </FormItem>
          <FormItem label="备注">
            <Input v-model="currentRes.remark" placeholder="备注"></Input>
          </FormItem>
        </Form>
      </lg-modal>
      <context-menu :menu="contextMenu" @onSelect="onMenuSelect"></context-menu>
    </template>
  </base-page>
</template>

<script>
import ResView from "../my-components/res-view";
import BasePage from "../my-components/base-page";
import util from '@/libs/util';
import ContextMenu from "../my-components/context-menu";
import LgModal from "../my-components/lg-modal";

const redisStat = {}
export default {
  name: 'page-res',
  components: {ContextMenu, BasePage, ResView, LgModal},
  data() {
    return {
      sysTab: ['sys', 'app'],
      showModal: false,
      loading: false,
      selectedId: 0,
      sysList: [],//系统res列表
      appList: [],//app res列表
      dtzjList: [],//电梯专家 res列表
      currentRes: {},
      contextMenu: {
        currentObj: null,
        show: false,
        position: {
          x: 0,
          y: 0
        },
        menus: []
      }
    };
  },
  computed: {},
  methods: {
    getResources() {
      util.ajax.get('/res/getlist', {
        params: {
          language: localStorage.getItem("language")
        }
      }).then((res) => {
        this.sysList = res.data.sys;
        this.appList = res.data.app;
        this.dtzjList = res.data.dtzj;
      });
    },
    onContextMenu(e, res, layer) {

      let menus = [
        {
          // icon: 'android-close',
          text: '删除资源',
          callback: 'deleteItem',
          show: true
        },
        {
          // icon: 'edit',
          text: '修改资源',
          callback: 'editItem',
          show: true
        },
        {
          // icon: 'plus',
          text: '新建子级',
          callback: 'addChild',
          show: true
        },
        {
          // icon: 'plus',
          text: '新建同级',
          callback: 'addSibling',
          show: true
        }
      ];
      if (layer == 3) {
        menus.splice(2, 1);
      }
      this.contextMenu.position = {
        x: e.clientX,
        y: e.clientY
      };
      this.contextMenu.menus = menus;
      this.contextMenu.show = true;
      this.contextMenu.currentObj = res;
    },
    copyText(text) {
      this.$copyText(text).then((e) => {
        this.$Notice.open({
          title: '复制成功',
          desc: text + '<br>已复制到剪贴板'
        });
      }).catch(e => {

      })
    },
    onMenuSelect(index) {
      this[this.contextMenu.menus[index].callback]();
    },
    setActive: function (res) {
      this.selectedId = res.id;
    },
    editItem() {
      this.showModal = true;
      this.currentRes = this.contextMenu.currentObj;
    },
    deleteItem() {
      let resource = this.contextMenu.currentObj;
      this.$Modal.confirm({
        title: '删除',
        content: '<p>确认删除资源 <b>' + resource.res_name + '</b> ？</p>',
        okText: '删除',
        cancelText: '取消',
        loading: true,
        onOk: () => {
          util.ajax.delete('/res/delete', {
            params: {id: resource.id}
          }).then((res) => {
            if (!res.code) {
              this.$Modal.remove();
              this.$Message.success('删除成功');
              this.getResources();
            } else {
              this.$Message.error('删除失败');
            }

          });
        }
      });

    },
    save() {
      this.loading = true;
      util.ajax.put('/res/save', this.currentRes).then((res) => {
        this.loading = false;
        if (!res.code) {
          this.$Message.success('保存成功');
          this.showModal = false;
          this.getResources();
        }
      });
    },
    addChild() {
      this.currentRes = {
        id: 0,
        res_name: '',
        res_name_en_us: '',
        res_key: '',
        res_type: this.contextMenu.currentObj.res_type,
        pid: this.contextMenu.currentObj.id,
        uri: this.contextMenu.currentObj.uri.slice(0, this.contextMenu.currentObj.uri.lastIndexOf('/') + 1),
        remark: '',
        children: []
      };
      this.showModal = true;
    },
    addSibling() {
      this.currentRes = {
        id: 0,
        res_name: '',
        pid: this.contextMenu.currentObj.pid,
        res_type: this.contextMenu.currentObj.res_type,
        res_key: '',
        uri: this.contextMenu.currentObj.uri.slice(0, this.contextMenu.currentObj.uri.lastIndexOf('/') + 1),
        remark: '',
        children: []
      };
      this.showModal = true;
    },
    startRedisTest() {
      let data;
      let ws = new WebSocket('ws://api.diantiyun.com/websocket/TESTMAIN');
      ws.onmessage = (e) => {

        try {
          data = JSON.parse(e.data);
          if (data.timestamp) {
            if (!redisStat[data.deviceName]) redisStat[data.deviceName] = {};
            redisStat[data.deviceName][data.action] = new Date(data.timestamp);
          }
        } catch (e) {
        }
      }
    },
    startRedisSTAT() {
    }
  },
  created() {
    this.getResources();
  },
  mounted() {

  },
};

</script>
<style scoped lang="less">
.tool-tip-content > p {
  cursor: pointer;
}

.menu1 > div, .menu2 > div {
  display: inline-block;
  vertical-align: middle;
  letter-spacing: 0;
}

.menu1, .menu2 {
  -webkit-text-size-adjust: none;
  word-spacing: 0;
  font-size: 0;
}

.auth-box {
  width: 100%;
}

.auth-res-item {
  font-size: 10px;
  display: inline-block;
  background-color: transparent;
  width: auto;
  border-radius: 2px;
  margin: 5px;
  float: left;
  padding: 0 5px;
  cursor: pointer;
}

.auth-box span.active {
  color: #fff;
}

.menu1 {
  width: 100%;
  box-sizing: border-box;
}

.menu-box1 {
  width: 20%;

}

.menu1-children {
  width: 80%;
}

.menu2 {
  width: 100%;
}

.menu2:last-child {
}

.menu-box2 {
  width: 30%;
}

.menu2-children {
  width: 66%;
}

.menu3, .menu-box3 {
  width: 100%;
}

.context-menu {
  width: 100px;
  height: auto;
  position: fixed;
}

.context-menu li {
  width: 100%;
  height: 25px;
  line-height: 25px;
  font-size: 13px;
  text-indent: 1em;
  cursor: pointer;
}

.context-menu li:hover {
  color: #fff;
}

.yellow {
  color: yellow;
}

h3 {
  margin: 20px 0 10px;
}
</style>
